import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import AddSingleItemUI from "../components/SingleItem/AddSingleItemUI";
import ScrollToProductsButton from "../../VehicleChooser/components/ScrollToProductsButton";

const isDev = (process.env.NODE_ENV == 'development');

export default function AddSingleItemContainer(props) {
  const {products} = props;

  let productList = _.values(products)

  if (_.isEmpty(productList)) {
    if (isDev) { return <div className="debug">AddSingleItemContainer: products not loaded</div>}
    return <div/>;
  }

  if (productList.length === 1) {
    return <AddSingleItemUI {...props} product={productList[0]}/>
  } else {
    // present a "Scroll to Options" button. This is wrapped in a .vehicle-selector
    // div for CSS purposes only
    return <div className="vehicle-selector"><ScrollToProductsButton/></div>;
  }
}

AddSingleItemContainer.propTypes = {
  products: PropTypes.object
};
